import React from "react";
import {
  UserOutlined,
  FireOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import "./index.less";

function Ksrm() {
  const data = [
    {
      title: "Agent开发平台快速入门（基于HiAgent）",
      content:
        "一、前言 在这个系列中，本系列设定了一个特别的目标：同时面向两个层面的读者。一方面，希望能够触及那些没有技术背景的普罗大众，帮助大家降低学习门槛，通过浅显易懂的语言理解如何使用AI来提高工作学习效率，让大家能够轻松地跟随并应用AI技术。 另一方面，期待那些已经拥有一定技术背景或实践经验的读者，能够在",
      time: "8月前",
      user: "Administrator",
      source: "快速入门",
      agree: 0,
      icon: "https://chatai-poc-cms.cloud.x-chain.tech/upload/thumbnails/2025/w400/Group1000003917.png",
      url:"https://chatai-poc-cms.cloud.x-chain.tech/archives/hiagent-kuai-su-ru-men"
    },
    {
      title: "快速创建专属Agent：自定义插件（基于HiAgent）",
      content:
        "一、进入自定义插件 进入个人空间，点击插件，点击自定义插件 二、填写插件配置",
      time: "6月前",
      user: "Administrator",
      source: "快速入门",
      agree: 0,
      icon: "https://chatai-poc-cms.cloud.x-chain.tech/upload/thumbnails/2025/w400/Group1000003961.png",
      url:"https://chatai-poc-cms.cloud.x-chain.tech/archives/kuai-su-chuang-jian-zhuan-shu-agent-zi-ding-yi-cha-jian"
    },
    {
      title: "快速创建专属Agent：创建知识库（基于HiAgent）",
      content:
        "一、知识库创建 1.知识库 这里的知识库指的是狭义的文件式的文本知识库，从广义上讲这里的知识库、问答库、术语库都是“知识库”。 ① 创建标准知识库（即通过文件的方式） 点击知识库 点击创建知识库",
      time: "6月前",
      user: "Administrator",
      source: "快速入门",
      agree: 0,
      icon: "https://chatai-poc-cms.cloud.x-chain.tech/upload/thumbnails/2025/w400/Group1000003961.png",
      url:"https://chatai-poc-cms.cloud.x-chain.tech/archives/kuai-su-chuang-jian-zhuan-shu-agent-chuang-jian-zhi-shi-ku"
    },
    {
      title: "Agent开发平台介绍-评测与对比（基于HiAgent）",
      content:
        "一、评测与对比介绍 本平台的“评测与对比”功能，旨在帮助您客观评估和比较AI应用（如智能体、模型或提示词策略）的实际表现，以便清晰了解其当前效果、优劣之处，并在多种方案中科学选优。简单来说，您可以将一次完整的评测任务理解为：选定要上场比试的“AI选手”（即您选择的测试对象是智能体、模型还是提示词），",
      time: "6月前",
      user: "Administrator",
      source: "快速入门",
      agree: 0,
      icon: "https://chatai-poc-cms.cloud.x-chain.tech/upload/thumbnails/2025/w400/Group1000003962.png",
      url:"https://chatai-poc-cms.cloud.x-chain.tech/archives/agentkai-fa-ping-tai-jie-shao-ping-ce-yu-dui-bi"
    },
    {
      title: "Agent开发平台介绍-数据库（基于HiAgent）",
      content:
        "一、数据库介绍 数据库允许用户以表格结构存储数据。这种数据存储方式适合组织和管理结构化数据，例如产品列表、订单记录等。 二、创建数据库 登陆 Agent 进入目标工作空间，在数据库内，点击创建数据库",
      time: "6月前",
      user: "Administrator",
      source: "快速入门",
      agree: 0,
      icon: "https://chatai-poc-cms.cloud.x-chain.tech/upload/thumbnails/2025/w400/Group1000003962.png",
      url:"https://chatai-poc-cms.cloud.x-chain.tech/archives/agentkai-fa-ping-tai-jie-shao-shu-ju-ku"
    },
    {
      title: "快速创建专属Agent：创建智能体（单Agent）（基于HiAgent）",
      content:
        "在介绍完工作流的基本组件之后，接下来我们将探讨如何在Agent开发平台上创建一个智能体。 创建智能体的步骤如下： 首先，你需要登录到Agent开发平台的首页并找到“创建智能体”字样。 点击创建按钮后，系统会提示你输入智能体的名称和类型。这里，你需要为Bot设定一个易于识别的名字，并简要描述它的功能和",
      time: "8月前",
      user: "Administrator",
      source: "快速入门",
      agree: 0,
      icon: "https://chatai-poc-cms.cloud.x-chain.tech/upload/thumbnails/2025/w400/Group1000003962.png",
      url:"https://chatai-poc-cms.cloud.x-chain.tech/archives/chuang-jian-zhi-neng-ti-duo-agent"
    },
    {
      title: "快速创建专属Agent：创建智能体（多Agent)（基于HiAgent）",
      content:
        "当单一Agent无法满足我们的使用需求时，我们将转向创建多Agent模式的智能体。首先，进入智能体的创建页面，然后选择进入编排模式。在编排页面中，我们选择多Agent模式，这将引导我们进入多Agent模式的详细编排页面。在这里，我们将对每个Agent进行配置，确保它们能够协同工作，以满足更复杂的业务",
      time: "8月前",
      user: "Administrator",
      source: "快速入门",
      agree: 0,
      icon: "https://chatai-poc-cms.cloud.x-chain.tech/upload/thumbnails/2025/w400/Group1000003962.png",
      url:"https://chatai-poc-cms.cloud.x-chain.tech/archives/chuang-jian-zhi-neng-ti-dan-agent"
    },
    {
      title: "Agent开发平台介绍-工作流（基于HiAgent）",
      content:
        "一、工作流介绍 平台的工作流（Workflow）是一系列有序的任务和操作，用于实现特定目标或完成特定业务流程。它可以包括多个步骤，每个步骤有特定任务和操作，可根据需要进行分支、循环和条件判断等。工作流的目的是提高工作效率、减少错误和重复劳动，同时提高业务流程的可控性和可管理性。 一般来说，工作流用于",
      time: "8月前",
      user: "Administrator",
      source: "快速入门",
      agree: 0,
      icon: "https://chatai-poc-cms.cloud.x-chain.tech/upload/thumbnails/2025/w400/Group1000003961.png",
      url:"https://chatai-poc-cms.cloud.x-chain.tech/archives/agentkai-fa-ping-tai-jie-shao-gong-zuo-liu"
    },
    {
      title: "Agent开发平台介绍-插件（基于HiAgent）",
      content:
        "一、插件介绍 插件是拓展大语言模型能力边界的关键一环 大语言模型训练好后就是静态的 它本身不能查询外部信息 需要接入插件来实现： 调用外部API 联网搜索 查询天气 执行代码 读取文件 做思维导图 由 平台官方或者其他用户提供的插件工具，也可以自己搭建自定义插件，这些插件涉及各类功能，如网页搜索、工",
      time: "8月前",
      user: "Administrator",
      source: "快速入门",
      agree: 0,
      icon: "https://chatai-poc-cms.cloud.x-chain.tech/upload/thumbnails/2025/w400/Group1000003961.png",
      url:"https://chatai-poc-cms.cloud.x-chain.tech/archives/cha-jian-jie-shao"
    },
    {
      title: "Agent开发平台介绍-知识库（基于HiAgent）",
      content:
        "RAG基本流程 知识库的关键就在于这张图：RAG的基本流程 把原始文档（如PPT、word、PDF等）切片，切成很多个知识片段。（模型无法把全文一次性处理）。 把每个知识片段向量化（如上所述）。 当用户提问时，会把用户的提问也向量化。 把向量化的用户提问去向量数据库去匹配（检索），基于语义相似度的原",
      time: "8月前",
      user: "Administrator",
      source: "快速入门",
      agree: 0,
      icon: "https://chatai-poc-cms.cloud.x-chain.tech/upload/thumbnails/2025/w400/Group1000003961.png",
      url:"https://chatai-poc-cms.cloud.x-chain.tech/archives/agentkai-fa-ping-tai-zhi-shi-ku"
    },
  ];

  return (
    <>
      <div style={{
        maxHeight:"650px",
        overflow:"scroll"
      }}>
        {data && data.length
          ? data.map((item) => {
              return (
                <div className="listItemCon">
                  <div className="desContent">
                    <div className="title"  style={{
                        cursor:"pointer"
                    }} onClick={() => {
                        window.open(item.url)
                    }}>{item.title}</div>
                    <div className="detail">{item.content}</div>
                    <div className="footer">
                      <span>
                        <span>
                          <ClockCircleOutlined />
                        </span>
                        <span>{item.time}</span>
                      </span>
                      <span>
                        <span>
                          <UserOutlined />
                        </span>
                        <span>{item.user}</span>
                      </span>
                      <span>
                        <span>
                          <FireOutlined />
                        </span>
                        <span>{item.agree}</span>
                      </span>
                    </div>
                  </div>
                  <div className="image" style={{
                    marginLeft:"20px"
                  }}>
                    <img
                      style={{
                        width: "150px",
                        height: "100px",
                        borderRadius:"5px"
                      }}
                      src={item.icon}
                      alt=" "
                    />
                  </div>
                </div>
              );
            })
          : undefined}
      </div>

    </>
  );
}

export default Ksrm;
